(function () {
  var SUPABASE_URL = 'https://xpjjvrjcjouylartupwy.supabase.co';
  // Public anon key fallback if theme meta/section settings are blank.
  var FALLBACK_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhwamp2cmpjam91eWxhcnR1cHd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk3MzQ3MTEsImV4cCI6MjA2NTMxMDcxMX0.OYbFjEfyO4IspmLKW8W9yqre-46GiqobE22yO7aUvLM';

  var POSITION_COPY = {
    barista: { foodHandler: true, license: false },
    bakery: { foodHandler: true, license: false },
    delivery: { foodHandler: false, license: true },
    roastery: { foodHandler: true, license: false },
  };

  var ROLES_WITH_COFFEE = { barista: true, roastery: true };
  var ROLES_WITH_WEEKEND = { barista: true, bakery: true, roastery: true };
  var ROLES_WITH_LOCATION = { barista: true };
  var ROLES_WITH_OPEN_OTHER = { barista: true, bakery: true };
  var ROLES_WITH_CULTURE = { barista: true, bakery: true, roastery: true };

  var DAY_LABELS = {
    monday: 'Mon', tuesday: 'Tue', wednesday: 'Wed', thursday: 'Thu',
    friday: 'Fri', saturday: 'Sat', sunday: 'Sun',
  };

  function ynValue(raw) {
    if (raw === 'yes') return true;
    if (raw === 'no') return false;
    return null;
  }

  function readMeta(name) {
    var el = document.querySelector('meta[name="' + name + '"]');
    return el ? el.getAttribute('content') || '' : '';
  }

  function resolveAnonKey(form) {
    return (
      form.getAttribute('data-supabase-anon-key') ||
      document.body.getAttribute('data-supabase-anon-key') ||
      readMeta('supabase-anon-key') ||
      FALLBACK_ANON_KEY ||
      ''
    );
  }

  function setMessage(form, text, isError) {
    var msg = form.querySelector('[data-careers-form-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.add('is-visible');
    msg.classList.toggle('is-error', !!isError);
  }

  function toggleDetails(select, detailsBlock, detailsField) {
    if (!select || !detailsBlock) return;
    var show = select.value === 'yes';
    detailsBlock.hidden = !show;
    if (detailsField) detailsField.required = show;
    if (!show && detailsField) detailsField.value = '';
  }

  function applyPositionUI(form, position) {
    var copy = POSITION_COPY[position];
    if (!copy) return;

    form.querySelectorAll('[data-role-only]').forEach(function (el) {
      var roles = (el.getAttribute('data-role-only') || '').split(',');
      el.hidden = roles.indexOf(position) === -1;
    });

    var primaryLocation = form.querySelector('[name="primary_location"]');
    if (primaryLocation) primaryLocation.required = !!ROLES_WITH_LOCATION[position];

    var openOther = form.querySelector('[name="open_to_other_locations"]');
    if (openOther) openOther.required = !!ROLES_WITH_OPEN_OTHER[position];

    var coffeeExp = form.querySelector('[name="coffee_experience"]');
    if (coffeeExp) coffeeExp.required = !!ROLES_WITH_COFFEE[position];

    var weekend = form.querySelector('[name="weekend_available"]');
    if (weekend) weekend.required = !!ROLES_WITH_WEEKEND[position];

    var culture = form.querySelector('[name="coffee_culture"]');
    if (culture) culture.required = !!ROLES_WITH_CULTURE[position];

    var foodBlock = form.querySelector('[data-food-handler-block]');
    var foodInput = form.querySelector('[name="food_handler_ok"]');
    if (foodBlock) foodBlock.hidden = !copy.foodHandler;
    if (foodInput) foodInput.required = !!copy.foodHandler;

    var licenseSelect = form.querySelector('[name="valid_license"]');
    if (licenseSelect) licenseSelect.required = !!copy.license;

    toggleDetails(
      form.querySelector('[name="service_industry_experience"]'),
      form.querySelector('[data-service-details]'),
      form.querySelector('[name="service_industry_details"]'),
    );
    toggleDetails(
      form.querySelector('[name="coffee_experience"]'),
      form.querySelector('[data-coffee-details]'),
      form.querySelector('[name="coffee_experience_details"]'),
    );
  }

  function bindAvailability(form) {
    form.querySelectorAll('[data-availability-day]').forEach(function (select) {
      select.addEventListener('change', function () {
        var day = select.getAttribute('data-availability-day');
        var times = form.querySelector('[data-availability-times="' + day + '"]');
        if (!times) return;
        var inputs = times.querySelectorAll('input');
        if (select.value === 'custom') {
          times.hidden = false;
          inputs.forEach(function (inp) { inp.disabled = false; });
        } else {
          times.hidden = true;
          inputs.forEach(function (inp) { inp.disabled = true; inp.value = ''; });
        }
      });
    });
  }

  function collectAvailability(form) {
    var data = { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, days: {} };
    var parts = [];
    Object.keys(DAY_LABELS).forEach(function (day) {
      var status = (form.querySelector('[name="availability_' + day + '"]') || {}).value || 'not_available';
      var start = (form.querySelector('[name="availability_' + day + '_start"]') || {}).value || '';
      var end = (form.querySelector('[name="availability_' + day + '_end"]') || {}).value || '';
      var dayData = { status: status };
      if (status === 'all_day') {
        dayData.start = '06:30';
        dayData.end = '18:00';
        parts.push(DAY_LABELS[day] + ': 6:30am-6:00pm');
      } else if (status === 'custom' && start && end) {
        dayData.start = start;
        dayData.end = end;
        parts.push(DAY_LABELS[day] + ': ' + start + '-' + end);
      } else {
        parts.push(DAY_LABELS[day] + ': Not available');
      }
      data.days[day] = dayData;
    });
    return { data: data, summary: parts.join('; ') };
  }

  function buildExperienceSummary(position, answers) {
    var parts = [];
    parts.push('Service industry: ' + (answers.service_industry_experience ? 'Yes' : 'No'));
    if (answers.service_industry_details) parts.push(answers.service_industry_details);
    if (ROLES_WITH_COFFEE[position]) {
      parts.push('Coffee industry: ' + (answers.coffee_experience ? 'Yes' : 'No'));
      if (answers.coffee_experience_details) parts.push(answers.coffee_experience_details);
    }
    return parts.join('\n');
  }

  var RESUME_MAX_BYTES = 5 * 1024 * 1024;
  var RESUME_EXTS = { pdf: true, doc: true, docx: true };

  function setResumeStatus(form, text, isError) {
    var el = form.querySelector('[data-resume-status]');
    if (!el) return;
    if (!text) {
      el.hidden = true;
      el.textContent = '';
      el.classList.remove('is-error');
      return;
    }
    el.hidden = false;
    el.textContent = text;
    el.classList.toggle('is-error', !!isError);
  }

  function sanitizeResumeName(name) {
    return String(name || 'resume')
      .replace(/[^a-zA-Z0-9._-]+/g, '_')
      .replace(/_+/g, '_')
      .slice(0, 80);
  }

  function getResumeFile(form) {
    var input = form.querySelector('[data-resume-input]');
    if (!input || !input.files || !input.files.length) return null;
    return input.files[0];
  }

  function validateResumeFile(file) {
    if (!file) return null;
    var ext = String(file.name.split('.').pop() || '').toLowerCase();
    if (!RESUME_EXTS[ext]) {
      return 'Please upload a PDF, DOC, or DOCX file.';
    }
    if (file.size > RESUME_MAX_BYTES) {
      return 'Resume must be 5 MB or smaller.';
    }
    return null;
  }

  function uploadResume(file, anon) {
    var ext = String(file.name.split('.').pop() || 'pdf').toLowerCase();
    var filename = 'careers_' + Date.now() + '_' + sanitizeResumeName(file.name);
    if (!/\.(pdf|doc|docx)$/i.test(filename)) {
      filename += '.' + ext;
    }

    return fetch(SUPABASE_URL + '/storage/v1/object/resumes/' + encodeURIComponent(filename), {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + anon,
        apikey: anon,
        'Content-Type': file.type || 'application/octet-stream',
        'x-upsert': 'false',
      },
      body: file,
    }).then(function (resp) {
      return resp.json().catch(function () { return {}; }).then(function (data) {
        if (!resp.ok) {
          var msg = (data && (data.error || data.message || data.statusCode)) || 'upload_failed';
          throw new Error(typeof msg === 'string' ? msg : 'upload_failed');
        }
        return {
          resume_url: SUPABASE_URL + '/storage/v1/object/public/resumes/' + filename,
          resume_filename: file.name,
        };
      });
    });
  }

  function buildPayload(form, resumeMeta) {
    var fd = new FormData(form);
    var availability = collectAvailability(form);
    var position = String(fd.get('position') || '');
    var serviceDetails = String(fd.get('service_industry_details') || '').trim();
    var coffeeDetails = String(fd.get('coffee_experience_details') || '').trim();
    var primaryLocation = String(fd.get('primary_location') || '').trim();

    var answers = {
      age_18_or_older: ynValue(fd.get('age_18_or_older')),
      visited_black_elm: String(fd.get('visited_black_elm') || '').trim(),
      primary_location: primaryLocation || null,
      open_to_other_locations: ynValue(fd.get('open_to_other_locations')),
      service_industry_experience: ynValue(fd.get('service_industry_experience')),
      service_industry_details: serviceDetails || null,
      coffee_experience: ynValue(fd.get('coffee_experience')),
      coffee_experience_details: coffeeDetails || null,
      weekend_available: ynValue(fd.get('weekend_available')),
      employment_type: String(fd.get('employment_type') || '').trim() || null,
      shifts_per_week: String(fd.get('shifts_per_week') || '').trim() || null,
      coffee_culture: String(fd.get('coffee_culture') || '').trim() || null,
      store_preference: primaryLocation || null,
      valid_license: fd.get('valid_license') === 'yes' ? true : fd.get('valid_license') === 'no' ? false : null,
      schedule_commitment: fd.get('schedule_commitment') === 'on',
      essential_functions_ok: fd.get('essential_functions_ok') === 'on',
      food_handler_ok: fd.get('food_handler_ok') === 'on',
      drug_free_ok: fd.get('drug_free_ok') === 'on',
      background_check_ok: fd.get('background_check_ok') === 'on',
      at_will_ok: fd.get('at_will_ok') === 'on',
      availability_notes: String(fd.get('availability_notes') || '').trim() || null,
      anything_else: String(fd.get('anything_else') || '').trim() || null,
    };

    answers.interest = answers.visited_black_elm;
    answers.experience = buildExperienceSummary(position, answers);

    var payload = {
      name: String(fd.get('name') || '').trim(),
      email: String(fd.get('email') || '').trim().toLowerCase(),
      phone: String(fd.get('phone') || '').trim(),
      password: String(fd.get('password') || '').trim(),
      position: position,
      availability_grid: availability.data,
      availability_text: availability.summary,
      answers: answers,
      surface: 'shopify_careers',
    };

    if (resumeMeta && resumeMeta.resume_url) {
      payload.resume_url = resumeMeta.resume_url;
      payload.resume_filename = resumeMeta.resume_filename || null;
    }

    return payload;
  }

  function bindForm(form) {
    var positionSelect = form.querySelector('[data-position-select]');
    positionSelect.addEventListener('change', function () {
      applyPositionUI(form, positionSelect.value);
    });

    ['service_industry_experience', 'coffee_experience'].forEach(function (name) {
      var select = form.querySelector('[name="' + name + '"]');
      if (!select) return;
      select.addEventListener('change', function () {
        var detailsBlock = name === 'service_industry_experience'
          ? form.querySelector('[data-service-details]')
          : form.querySelector('[data-coffee-details]');
        var detailsName = name === 'service_industry_experience'
          ? 'service_industry_details'
          : 'coffee_experience_details';
        var detailsField = form.querySelector('[name="' + detailsName + '"]');
        toggleDetails(select, detailsBlock, detailsField);
      });
    });

    var licenseSelect = form.querySelector('[name="valid_license"]');
    var licenseWarn = form.querySelector('[data-license-warning]');
    if (licenseSelect && licenseWarn) {
      licenseSelect.addEventListener('change', function () {
        licenseWarn.hidden = licenseSelect.value !== 'no';
      });
    }

    var ageSelect = form.querySelector('[name="age_18_or_older"]');
    var ageWarn = form.querySelector('[data-age-warning]');
    if (ageSelect && ageWarn) {
      ageSelect.addEventListener('change', function () {
        ageWarn.hidden = ageSelect.value !== 'no';
      });
    }

    bindAvailability(form);
    applyPositionUI(form, positionSelect.value || '');

    var resumeInput = form.querySelector('[data-resume-input]');
    if (resumeInput) {
      resumeInput.addEventListener('change', function () {
        var file = getResumeFile(form);
        var err = validateResumeFile(file);
        if (err) {
          setResumeStatus(form, err, true);
          resumeInput.value = '';
          return;
        }
        if (file) setResumeStatus(form, 'Selected: ' + file.name, false);
        else setResumeStatus(form, '', false);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var anon = resolveAnonKey(form);
      if (!anon) {
        setMessage(form, 'Configuration error — please email careers@blackelm.coffee.', true);
        return;
      }

      var ageEl = form.querySelector('[name="age_18_or_older"]');
      if (!ageEl || ageEl.value !== 'yes') {
        setMessage(form, 'Black Elm Coffee only hires people who are 18 or older.', true);
        return;
      }

      var resumeFile = getResumeFile(form);
      var resumeErr = validateResumeFile(resumeFile);
      if (resumeErr) {
        setResumeStatus(form, resumeErr, true);
        setMessage(form, resumeErr, true);
        return;
      }

      var submitBtn = form.querySelector('[type="submit"]');
      var defaultLabel = submitBtn ? (submitBtn.getAttribute('data-default-label') || submitBtn.textContent) : 'Submit';
      var payload;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = resumeFile ? 'Uploading resume…' : 'Submitting…';
      }

      var resumePromise = resumeFile
        ? uploadResume(resumeFile, anon).then(function (meta) {
          setResumeStatus(form, 'Resume uploaded.', false);
          if (submitBtn) submitBtn.textContent = 'Submitting…';
          return meta;
        })
        : Promise.resolve(null);

      resumePromise
        .then(function (resumeMeta) {
          payload = buildPayload(form, resumeMeta);
          return fetch(SUPABASE_URL + '/functions/v1/submit-applicant-application', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + anon,
              apikey: anon,
            },
            body: JSON.stringify(payload),
          });
        })
        .then(function (resp) {
          return resp.json().then(function (data) {
            return { ok: resp.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.data || !result.data.success) {
            var details = (result.data && result.data.details) ? result.data.details.join(' ') : '';
            throw new Error((result.data && result.data.error) || details || 'submit_failed');
          }

          form.hidden = true;
          var success = document.querySelector('[data-careers-success]');
          if (success) {
            success.hidden = false;
            var emailEl = success.querySelector('[data-success-email]');
            var passEl = success.querySelector('[data-success-password]');
            var portalLink = success.querySelector('[data-success-portal-link]');
            if (emailEl) emailEl.textContent = payload.email;
            if (passEl) passEl.textContent = payload.password;
            if (portalLink && result.data.portal_url) portalLink.href = result.data.portal_url;
          }
        })
        .catch(function (err) {
          setMessage(form, 'Something went wrong: ' + (err.message || 'please try again or email careers@blackelm.coffee.'), true);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = defaultLabel;
          }
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-careers-application-form]').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
